import type { Device } from '../types/room';

/**
 * Demo room devices, used only while no RCU configuration has been defined on
 * this tablet (see `useRcuConfigStore`). Fixtures are plain data validated by
 * the `Device` type, so they are exempt from the raw-constant lint ban.
 */
export const mockDevices: Device[] = [
  // Switched lights
  { id: 'desk-lamp', name: 'Desk Lamp', type: 'light', status: 'off', icon: 'LampDesk', isOnline: true, category: 'bedroom' },
  { id: 'bed-lamp-1', name: 'Bed Lamp 1', type: 'light', status: 'off', icon: 'Lamp', isOnline: true, category: 'bedroom' },
  { id: 'bed-lamp-2', name: 'Bed Lamp 2', type: 'light', status: 'off', icon: 'Lamp', isOnline: true, category: 'bedroom' },
  { id: 'passage', name: 'Passage Lights', type: 'light', status: 'off', icon: 'Lightbulb', isOnline: true, category: 'passage' },

  // Dimmable lights
  { id: 'bed-ceiling', name: 'Bed Ceiling Lights', type: 'dimmable-light', status: 'off', icon: 'Lightbulb', isOnline: true, category: 'bedroom', brightness: 80 },
  { id: 'living-chandelier', name: 'Living Chandelier', type: 'dimmable-light', status: 'off', icon: 'Lightbulb', isOnline: true, category: 'living', brightness: 60 },

  // Air conditioner
  { id: 'ac', name: 'Air Conditioner', type: 'ac', status: 'off', icon: 'Snowflake', isOnline: true, category: 'bedroom', temperature: 24, targetTemp: 22, mode: 'cool' },

  // Curtains
  { id: 'sheer-curtains', name: 'Sheer Curtains', type: 'curtain', status: 'off', icon: 'Square', isOnline: true, category: 'bedroom', position: 0 },
  { id: 'blackout-curtains', name: 'Blackout Curtains', type: 'curtain', status: 'off', icon: 'Square', isOnline: true, category: 'bedroom', position: 0 },

  // Television
  { id: 'tv', name: 'Television', type: 'tv', status: 'off', icon: 'Monitor', isOnline: true, category: 'living' },
];
